import { createContext, useContext } from 'react'
import { VoiceContextType } from './types'

// Create context with default values
export const VoiceContext = createContext<VoiceContextType>({
  isSessionActive: false,
  isListening: false,
  isConnecting: false,
  isResponding: false,
  isPreparingResponse: false,
  reasoningStatus: null,
  speakingTranscript: null,
  startSession: async (osAssistantCode: string, orgId?: number, projectId?: number) => {},
  stopSession: () => {},
  startListening: async () => {},
  stopListening: () => {},
  logs: [],
  toolCall: null,
  updateState: () => {},
  clearSessionState: () => {},
})

export const useVoice = () => {
  const context = useContext(VoiceContext)
  if (!context) {
    throw new Error('useVoice must be used within a VoiceProvider')
  }
  return context
}
